module.exports = __webpack_public_path__ + "img/search-miniprogram.02e801e4.png";